module.exports = __webpack_public_path__ + "static/media/search.d4ab5bd4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/search.svg
// module id = 1162
// module chunks = 0